import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header/Header';
import Textarea from '../Textarea/Textarea';

import styles from './index.module.scss';

function Step3({
  current, size, data, getState, handleChange, handleClose
}) {
  return (
    <div className={styles.wrapper}>
      <Header current={current} size={size} occupation={data.occupation_name} business={data.business_name} handleClose={handleClose} />
      <div className={styles.body}>
        <p className={styles.title}>Please provide details of the service you require.</p>
        <Textarea
          label="Additional notes or comments..."
          type="text"
          name="notes"
          value={getState('notes', '')}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

Step3.propTypes = {
  data: PropTypes.shape({
    occupation_name: PropTypes.string,
    occupation_id: PropTypes.number,
    business_name: PropTypes.string,
  }),
  getState: PropTypes.func,
  handleChange: PropTypes.func,
  current: PropTypes.number,
  size: PropTypes.number,
  handleClose: PropTypes.func,
};

export default Step3;
